import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userConfirmEmail } from "../../store/auth/actions";
export var UseUserConfirmEmail = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseConfirmEmail: (_a = state.Login.responseConfirmEmail) === null || _a === void 0 ? void 0 : _a.data,
            errorConfirmEmail: state.Login.errorConfirmEmail,
            loadingConfirmEmail: state.Login.loadingConfirmEmail,
        });
    }), responseConfirmEmail = _a.responseConfirmEmail, errorConfirmEmail = _a.errorConfirmEmail, loadingConfirmEmail = _a.loadingConfirmEmail;
    useEffect(function () {
        if (trigger) {
            dispatch(userConfirmEmail(bodyRequest));
        }
    }, [bodyRequest, trigger]);
    return {
        responseConfirmEmail: responseConfirmEmail,
        errorConfirmEmail: errorConfirmEmail,
        loadingConfirmEmail: loadingConfirmEmail,
    };
};
